<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zmiana ilości kartonów
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model.number="parcel.numberOfPackages"
                            type="number"
                            min="1"
                            :max="maxNumberOfBoxes"
                            label="Ilość kartonów"
                            outlined
                            required
                            :error-messages="numberOfPackagesErrors"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="updateParcel"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { appConfig } from '@/config'
import { required, between } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
    name: 'ParcelPackagesAmountDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        parcelData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            parcel: {
                numberOfPackages: null
            },
            minNumberOfBoxes: null
        }
    },
    validations() {
        return {
            parcel: {
                numberOfPackages: {
                    required: required,
                    between: between(this.minNumberOfBoxes, this.maxNumberOfBoxes)
                }
            }
        }
    },
    computed: {
        maxNumberOfBoxes() {
            return appConfig.sendings.boxMaxCount
        },
        numberOfPackagesErrors() {
            const errors = []

            if (!this.$v.parcel.numberOfPackages.$dirty) return errors

            if (!this.$v.parcel.numberOfPackages.required || !this.$v.parcel.numberOfPackages.between) {
                errors.push(`Proszę podać wartość z zakresu ${this.minNumberOfBoxes}-${this.maxNumberOfBoxes}`)

            }

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.parcel = JSON.parse(JSON.stringify(this.parcelData))
                this.minNumberOfBoxes = this.parcel.numberOfPackages
            }
        }
    },
    methods: {
        updateParcel() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            this.$emit('update-parcel', {parcel: this.parcel})
            this.onClose()
        },
        onClose() {
            this.$v.$reset()
            setTimeout(() => {
                this.parcel = JSON.parse(JSON.stringify(this.parcelData))
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>